import React from 'react';
import { SparklesIcon, ZapIcon, TrendingUpIcon } from 'lucide-react';
const benefits = [{
  icon: SparklesIcon,
  title: 'Aprendé en 24 horas',
  description: 'Método paso a paso para crear tabletas profesionales'
}, {
  icon: ZapIcon,
  title: 'Inversión mínima',
  description: 'Empezá con poco y crecé a medida que vendés'
}, {
  icon: TrendingUpIcon,
  title: 'Producto que se vende',
  description: 'Alta demanda y excelentes márgenes de ganancia'
}];
export function NewSolutionSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-244">
      <div className="container mx-auto max-w-6xl" data-id="element-245">
        <div className="backdrop-blur-sm bg-gradient-to-br from-white/90 to-pink-50/50 rounded-3xl border-2 border-[#FF4DB8]/20 shadow-lg shadow-pink-500/10 p-8 md:p-12" data-id="element-246">
          <div className="text-center mb-12" data-id="element-247">
            <div className="inline-block px-4 py-2 bg-gradient-to-r from-[#FFD6EC] to-[#FFB3E6] rounded-full mb-4" data-id="element-248">
              <span className="text-sm font-bold text-[#FF4DB8]" data-id="element-249">
                LA SOLUCIÓN
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-250">
              Tabletas aromáticas que generan ingresos
            </h2>
            <p className="text-lg text-[#6B6B6B] max-w-2xl mx-auto" data-id="element-251">
              Sistema completo para crear, vender y escalar tu negocio
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-252">
            {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return <article key={index} className="text-center" data-id="element-253">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#FF4DB8] to-[#FF6EC7] rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-md shadow-pink-500/20" data-id="element-254">
                    <Icon className="w-8 h-8 text-white" aria-hidden="true" data-id="element-255" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-256">
                    {benefit.title}
                  </h3>
                  <p className="text-[#6B6B6B]" data-id="element-257">{benefit.description}</p>
                </article>;
          })}
          </div>
        </div>
      </div>
    </section>;
}